import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQS } from "../../data/content";
import { Reveal, SectionHeading } from "./Reveal";
import { useSite } from "../../context/SiteContext";

const FAQ = () => {
  const { openBooking } = useSite();
  return (
    <section id="faq" className="bg-slate-50 dark:bg-[#0A1030] py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-16">
        <div className="lg:sticky lg:top-32 self-start">
          <SectionHeading
            id="faq"
            overline="FAQ"
            title={<>Questions physicians <span className="text-brand-gradient">ask us most</span></>}
            sub="Pricing, onboarding, compliance, and how live human scribing actually works in your practice."
          />
          <Reveal delay={0.15}>
            <button
              data-testid="faq-book-call-button"
              onClick={openBooking}
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-navy dark:bg-brand-sky text-white dark:text-brand-ink font-bold px-7 py-3.5 text-sm hover:shadow-[0_16px_40px_-14px_rgba(42,49,146,0.55)] hover:-translate-y-0.5 transition-[transform,box-shadow] duration-300"
            >
              Still have questions? Book a call
            </button>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={f.q}
                value={`faq-${i}`}
                className="rounded-2xl bg-white dark:bg-white/5 border border-slate-100 dark:border-white/10 px-6 data-[state=open]:shadow-[0_20px_50px_-30px_rgba(42,49,146,0.35)] transition-shadow duration-300"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left font-display text-base md:text-lg font-semibold text-slate-900 dark:text-white hover:no-underline py-5"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-[15px] leading-relaxed text-slate-600 dark:text-slate-300 pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
export default FAQ;
